{
  "es": {
    "pagination": {
      "previous": "Página anterior",
      "next": "Página siguiente",
      "page_report": "Página {page} de {total}",
      "report": "Mostrando {first} a {last} de {total}",
      "total": "Total de elementos: {total}"
    }
  }
}
